import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation  } from 'react-router-dom';

import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';


function FamilyRequestAccepted() {
  
 const navigate = useNavigate();
 const location = useLocation();
  
  const queryParams = new URLSearchParams(location.search);
  const verifyCode = queryParams.get("verifyCode");


  const { data: userCode, isLoadingCode, isErrorCode } = useQuery({
    queryKey: ["user-code", verifyCode], // include in cache key
    queryFn: () =>
      axios
        .get(`${API_URL}/family-request-accepted-verifycode-api?verifyCode=${verifyCode}`, { 
          withCredentials: true 
        })
        .then((response) => response.data),
    enabled: !!verifyCode, //only run if verifyCode exists
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: "always",
  refetchOnWindowFocus: "always",
  });




  if (isLoadingCode) return <div className="loadingspinnerDiv">
  <div className="loadingspinner"></div>
</div>;
  if (isErrorCode) return <p>Error fetching details</p>;

  return (
    

    <div className='main-wrapper'>
          <div className='content container-fluid'>
    

    {userCode?.Status === "Success" ? (
  <>

<div
  className="d-flex justify-content-center align-items-center" >
<div
    className="card shadow-lg text-center p-5 mt-4"
    style={{ maxWidth: "500px", borderRadius: "0px" }}
  >
    {/* Warning Icon */}
    <div className="mb-4">
      <div
        className="d-inline-flex align-items-center justify-content-center rounded-circle"
        style={{
          width: "70px",
          height: "70px",
          backgroundColor: "#184A2C",
        }}
      >
         
        <i className="fa fa-info text-success fs-2"></i>
      </div>
    </div>

    {/* Title */}
    <h3 className="fw-bold text-success">Hello {userCode.user.name} {userCode.user.last_name}</h3>

    {/* Message */}
    <p className="text-muted mt-3">
    Kindly proceed to add your details on to the tree
    </p>

    <button
              onClick={() =>
                navigate("/family-request-accepted-tree", {
                  state: { first_name: userCode.user.name,  last_name: userCode.user.last_name, family_code: userCode.user.family_code },
                })
              }
              className="btn btn-primary"
            >
              Proceed
            </button>

    </div>
  </div>

   
  </>
) : (
  
  <div
  className="d-flex justify-content-center align-items-center" >
<div
    className="card shadow-lg text-center p-5 mt-4"
    style={{ maxWidth: "500px", borderRadius: "0px" }}
  >
    {/* Warning Icon */}
    <div className="mb-4">
      <div
        className="d-inline-flex align-items-center justify-content-center rounded-circle"
        style={{
          width: "70px",
          height: "70px",
          backgroundColor: "#ffe6e6",
        }}
      >
         
        <i className="fa fa-exclamation-triangle text-danger fs-2"></i>
      </div>
    </div>

    {/* Title */}
    <h3 className="fw-bold text-danger">Link Expired</h3>

    {/* Message */}
    <p className="text-muted mt-3">
      Sorry, the link has expired.
    </p>

    </div>
  </div>

)}

<div className='row mt-4' style={{marginTop: '5%'}}></div>


        </div>
        </div>
  );
}

export default FamilyRequestAccepted;
